import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export type DateRangeFilterType = 'DAILY' | 'WEEKLY';

type UseDateRangeFilterTypeProps = {
    filterKey: string;
    defaultValue?: DateRangeFilterType;
};

export const useDateRangeFilterType = ({
    filterKey,
    defaultValue = 'DAILY',
}: UseDateRangeFilterTypeProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { pathname } = useLocation();

    const dateRangeFilterTypeParam = searchParams.get(filterKey) as DateRangeFilterType | null;

    useEffect(() => {
        if (dateRangeFilterTypeParam) {
            return;
        }

        setSearchParams(
            (prevSearchParams) => {
                prevSearchParams.set(filterKey, defaultValue);
                return prevSearchParams;
            },
            { replace: true },
        );
    }, [dateRangeFilterTypeParam, defaultValue, filterKey, pathname, setSearchParams]);

    const handleChangeDateRangeFilterType = (dateRangeFilterType: DateRangeFilterType) =>
        setSearchParams(
            (prevSearchParams) => {
                prevSearchParams.set(filterKey, dateRangeFilterType);
                return prevSearchParams;
            },
            { replace: true },
        );

    return {
        dateRangeFilterType: dateRangeFilterTypeParam || defaultValue,
        handleChangeDateRangeFilterType,
    };
};
